import { render, staticRenderFns } from "./CreatePaymentSettlementKasbon.vue?vue&type=template&id=5b35dad5"
import script from "./CreatePaymentSettlementKasbon.vue?vue&type=script&lang=js"
export * from "./CreatePaymentSettlementKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports